import { createAction } from "redux-actions";
import { UserProfileConstants } from "../constants/userProfile.constants";

export const userProfileInit = createAction(
    UserProfileConstants.USER_PROFILE_INIT
);

export const userProfileInitSuccess = createAction(
    UserProfileConstants.USER_PROFILE_INIT_SUCCESS
);

export const userProfileInitFailure = createAction(
    UserProfileConstants.USER_PROFILE_INIT_FAILURE
);

export const userCorrections = createAction(
    UserProfileConstants.USER_CORRECTIONS
);

export const userCorrectionsSuccess = createAction(
    UserProfileConstants.USER_CORRECTIONS_SUCCESS
);

export const userCorrectionsFailure = createAction(
    UserProfileConstants.USER_CORRECTIONS_FAILURE
);

export const userPosts = createAction(UserProfileConstants.USER_POSTS);

export const userPostsSuccess = createAction(
    UserProfileConstants.USER_POSTS_SUCCESS
);

export const userPostsFailure = createAction(
    UserProfileConstants.USER_POSTS_FAILURE
);

export const resetUserProfile = createAction(
    UserProfileConstants.RESET_USER_PROFILE
);



// WEBPACK FOOTER //
// ./src/actions/userProfile.actions.js